import type { Variants } from "motion/react"

export const authCardClass =
	"flex w-full max-w-md flex-col items-stretch gap-0 rounded-3xl border border-zinc-200/80 bg-white px-8 py-8 shadow-lg"

export const staggerContainer: Variants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: { staggerChildren: 0.06, delayChildren: 0 },
	},
}

export const staggerItem: Variants = {
	hidden: { opacity: 0, y: 14 },
	visible: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
	},
}
